import React, {useState} from "react";
import {Input, Label, Form, FormFeedback, Spinner, FormGroup, Row, Col} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import {useFormik} from "formik";

import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// action
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {appConfig} from "../../config";
import PhoneNumberField from "../../Components/PhoneNumberField";

const Register = (props) => {
    const {t} = useTranslation();

    const {isForDemo, price} = useSelector(state => state.requestDemo);

    const [loading, setLoading] = useState(false);
    const [resendReuqest, setResendRequest] = useState(false);
    const [userID, setUserID] = useState(0);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            fullName: '',
            phone: '',
            countryCode: '',
            companyName: "",
            employeesNumber: ''
        },
        validationSchema: Yup.object().shape({
            fullName: Yup.string()
                .required(t("t-name-surname-helper")),
            companyName: Yup.string()
                .required(t("t-company-name-helper")),
            phone: Yup.string()
                .required(t("t-phone-helper")),
            employeesNumber: Yup.number()
                .required(t('t-emp-number-helper'))
        }),
        onSubmit: async (values) => {
            setLoading(true);
            let response = await fetch(appConfig.baseUrl.concat('/register-advertisement-user'), {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "login": 'HRplus+',
                    "password": 'Ctc0oTYayc77z'
                },
                body: JSON.stringify(!resendReuqest ? values : {
                    user_id: userID,
                    isForDemo: isForDemo,
                    price: price
                })
            })
                .then(resp => resp.json())
                .catch(err => {
                    console.log(err);
                    toast.error(t('t-server-out-of-work'));
                })
                .finally(() => {
                    setLoading(false);
                });

            if (resendReuqest) {
                if (response['status']) {
                    toast.success(t());
                    props.toggleModal();
                } else
                    toast.error(t("t-server-error"));

            } else {
                if (response['exist']) {
                    toast.error(t("t-phone-exist"));
                    setResendRequest(true);
                    setUserID(response['id']);
                } else if (!response['status']) {
                    toast.error(t("t-server-error"));
                    setResendRequest(false);
                } else {
                    props.toggle(1);
                    props.changeUSerID(response['id']);
                    setResendRequest(false);
                }
            }
        }
    });

    return (
        <>
            <h5 className="text-primary text-center mb-4 fs-14">
                {isForDemo ? t('t-use-demo-version-info') : t('t-use-demo-version-info2')}
            </h5>
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <Row className={"g-3"}>
                    <Col xs={12}>
                        <Label htmlFor="fullName">
                            {t('t-name-surname')} <span className="text-danger">*</span></Label>
                        <Input
                            id="fullName"
                            name="fullName"
                            type="text"
                            // placeholder={t('t-name-surname-placeholder')}
                            onChange={validation.handleChange}
                            value={validation.values.fullName || ""}
                            invalid={
                                !!(validation.touched.fullName && validation.errors.fullName)
                            }
                        />
                        {validation.touched.fullName && validation.errors.fullName ? (
                            <FormFeedback type="invalid">
                                <div>{validation.errors.fullName}</div>
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col xs={12}>
                        <Label htmlFor="companyName">
                            {t('t-company-name')} <span className="text-danger">*</span>
                        </Label>
                        <Input
                            id="companyName"
                            name="companyName"
                            type="text"
                            // placeholder={t('t-company-name-placeholder')}
                            onChange={validation.handleChange}
                            value={validation.values.companyName || ""}
                            invalid={
                                !!(validation.touched.companyName && validation.errors.companyName)
                            }
                        />
                        {validation.touched.companyName && validation.errors.companyName ? (
                            <FormFeedback type="invalid">
                                <div>{validation.errors.companyName}</div>
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col xs={12}>
                        <Label htmlFor="employeesNumber">
                            {t('t-emp-number')} <span className="text-danger">*</span></Label>
                        <Input
                            id="employeesNumber"
                            name="employeesNumber"
                            type="number"
                            // placeholder={t('t-emp-number-placeholder')}
                            onChange={validation.handleChange}
                            value={validation.values.employeesNumber || ""}
                            invalid={
                                !!(validation.touched.employeesNumber && validation.errors.employeesNumber)
                            }
                        />
                        {validation.touched.employeesNumber && validation.errors.employeesNumber ? (
                            <FormFeedback type="invalid">
                                <div>{validation.errors.employeesNumber}</div>
                            </FormFeedback>
                        ) : null}
                    </Col>
                    <Col xs={12}>
                        <PhoneNumberField
                            value={validation.values.phone}
                            onChange={validation.handleChange}
                            onChangeCountryCode={code => {
                                validation.setFieldValue("countryCode", code);
                                validation.setFieldValue("phone", '');
                            }}
                            error={validation.touched.phone && validation.errors.phone ? validation.errors.phone : false}
                            label={t('t-phone')}
                            name={"phone"}
                        />
                    </Col>
                </Row>

                <div className="mt-4">
                    <button
                        className="btn btn-success w-100 d-flex align-items-center gap-2 justify-content-center"
                        type="submit"
                        disabled={loading}
                    >
                        {loading && <Spinner size={"sm"} type={"grow"}/>}
                        {resendReuqest ? t('t-request-use-again') : t('t-register')}
                    </button>
                </div>
            </Form>
            {isForDemo && <div className="mt-3 text-center">
                <p className="mb-0">
                    {t("t-request-register-before")}
                    <Link className="fw-semibold text-primary text-decoration-underline ms-2"
                          to={appConfig.baseUrl.concat("/login")}
                          target="_blank"
                    >
                        {t('t-login')}
                    </Link>
                </p>
            </div>}
        </>
    );
};

export default Register;